<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <UPDATE ref="childUpdate" @submit="submit" :updateData="updateData" @uploadFile="uploadFile"></UPDATE>
    <table-page ref="childTable" @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData"></table-page>
  </div>
</template>

<script>
import tablePage from '@/components/page/table.vue'
import FORM from '@/components/page/form.vue'
import DateUtil from '@/utils/IM/tradeDataUtil.js'
import Qs from 'qs'
import Url from '@/views/crs/util/url'
import UPDATE from '@/components/page/update'

let finishedStatusArr = { 0: '未完成', 1: '已完成' }
let awardStatusArr = { 0: '未领取', 1: '已领取' }
let specialTasks = {}
export default {
  name: 'list',
  components: {
    tablePage,
    FORM,
    UPDATE
  },
  created() {
    this.initSpecialTasks()
  },
  methods: {
    checkbox(row) {
      this.deleteIds = row.map(key => key.id).join(',')
      if (this.deleteIds.length <= 0) return
    },
    uploadFile(col, result) {
      col.data = (result || []).join(',')
    },
    initSpecialTasks() {
      this.$axios.get(Url.quantityTask.dailyTaskCategory, {
        params: {
          businessTypeAlias: DateUtil.getParamKey(this.$route.params)
        }
      }).then(res => {
        if (res.code == 0) {
          for (const elem of res.result) {
            if (elem.category == 4) {
              for (const task of elem.taskDetailList) {
                specialTasks[task.taskId] = task.taskName
              }
              return
            }
          }
        }
      })
    },
    /*新增或跟提交数据触发事件*/
    submit(model) {
      this.dataChange(Url.quantityTask.specialUpload, model, res => {
        if (res.code == 0) {
          this.$refs.childUpdate.close()
          this.$message.success('操作成功')
          this.$refs.childTable.defaultGetData(this.queryData)
        } else {
          this.$message.error(res.message)
        }
      })
    },

    /*查询表单按钮点击事件*/
    formclick(clickName, data) {
      if (window.$t('common.search') == clickName || '查询' == clickName) {
        this.queryData = data
        this.$refs.childTable.defaultGetData(data)
      } else if (window.$t('crs.bt.upload') == clickName || '上传' == clickName) {
        this.$refs.childUpdate.open()
      } else if (window.$t('crs.bt.delete') == clickName || '刪除' == clickName) {
        this.dataChange(Url.quantityTask.specialDel, {
          ids: this.deleteIds,
          businessTypeAlias: DateUtil.getParamKey(this.$route.params)
        }, res => {
          if (res.code == 0) {
            this.$message.success('suc')
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },

    /*表格按钮点击事件*/
    bthClick(clickName, row) {
      if (clickName == 'delete') {
        this.dataChange(Url.quantityTask.specialDel, {
          ids: row.id,
          businessTypeAlias: DateUtil.getParamKey(this.$route.params)
        }, res => {
          if (res.code == 0) {
            this.$message.success('suc')
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },

    dataChange(url, option, suc, fail) {
      this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        this.$refs.childTable.defaultGetData(this.queryData)
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    }

  },
  data() {
    return {
      deleteIds: '',
      queryData: {},
      updateData: {
        cols: [
          {
            title: '用戶列表',
            field: 'customers',
            type: 11,
            action: Url.utils.uploadFile,
            downUrl: 'https://static.chwenda.com/source/downloadModel/消息推送用户模板.xlsx',
            required: true
          },
          {
            title: 'businessTypeAlias',
            field: 'businessTypeAlias',
            data: DateUtil.getParamKey(this.$route.params),
            hidden: true
          },
          { title: '任务', field: 'taskId', type: 2, optionList: specialTasks, multiple: false, required: true }
        ]
      },
      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          {
            title: 'businessTypeAlias',
            field: 'businessTypeAlias',
            data: DateUtil.getParamKey(this.$route.params),
            hidden: true
          },
          { title: window.$t('crs.quantityTask.customerNumber'), field: 'customerNumber', isNumber: true },
          {
            title: window.$t('crs.quantityTask.finishedStatus'),
            field: 'finishedStatus',
            type: 2,
            optionList: finishedStatusArr,
            multiple: false
          },
          {
            title: window.$t('crs.quantityTask.awardStatus'),
            field: 'awardStatus',
            type: 2,
            optionList: awardStatusArr,
            multiple: false
          },
          { click: window.$t('common.search') },
          { click: window.$t('crs.bt.upload'), auth: 'crs:special:upload' },
          { click: window.$t('crs.bt.delete'), auth: 'crs:special:del' }
        ]
      },
      /*table生成*/
      pageData: {
        isShow: false,
        queryUrl: Url.quantityTask.specialList,
        selection: true,
        sequence: true,
        method: 'get',
        cols: [
          { title: 'ID', field: 'id' },
          {
            title: window.$t('crs.quantityTask.ctime'), field: 'ctime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          { title: window.$t('crs.quantityTask.customerNumber'), field: 'customerNumber' },
          { title: window.$t('crs.quantityTask.taskName'), field: 'taskName' },
          { title: window.$t('crs.quantityTask.quantity'), field: 'quantity' },
          {
            title: window.$t('crs.quantityTask.awardStatus'), field: 'awardStatus', render: (data, full) => {
              return awardStatusArr[data]
            }
          },
          {
            title: window.$t('crs.quantityTask.finishedStatus'), field: 'finishedStatus', render: (data, full) => {
              return finishedStatusArr[data]
            }
          },
          { title: window.$t('crs.quantityTask.typeName'), field: 'typeName' },
          {
            title: window.$t('crs.bt.operation'),
            btnClick: [
              {
                name: window.$t('crs.bt.delete'),
                click: 'delete',
                type: 'primary',
                icon: 'el-icon-delete',
                auth: 'crs:special:del'
              }]
          }
        ]
      }
    }
  }
}
</script>
